<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" placeholder="搜索名称" />
            </a-form-item>
          </a-col>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd">新建</a-button>
      <!--<a-dropdown v-if="selectedRowKeys.length > 0">-->
      <!--<a-menu slot="overlay">-->
      <!--<a-menu-item @click="setAllStatus(1)" key="1"><a-icon type="upload" />开启</a-menu-item>-->
      <!--<a-menu-item @click="setAllStatus(2)" key="2"><a-icon type="download" />关闭</a-menu-item>-->
      <!--</a-menu>-->
      <!--<a-button style="margin-left: 8px">-->
      <!--批量操作 <a-icon type="down" />-->
      <!--</a-button>-->
      <!--</a-dropdown>-->
    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="title1" slot-scope="text,record">
        <div style="margin-bottom: 10px;">{{record.name}}</div>
        <div>
          <img style="width: 68px ; height: 68px; float: left" :src="record.pic_url" />
          <div style="color: #999;margin-left: 10px; float: left">
            <!--最高减 <span style="color: #f5212d">¥{{record.pen_price}}</span>-->
            <br />
            <!--人数限制: {{record.pen_data.length}}-->
            <br />
            <!--<a-badge status="success" v-if="record.status==1" text="运营中" />-->
            <!--<a-badge status="default" v-else text="关闭" />-->
          </div>
        </div>
      </span>

      <span slot="rank" slot-scope="text,record">
        <template>
          <editable-cell :text="text" @change="onRankChange(record.id, 'rank', $event)" />
        </template>
      </span>
      <span slot="action" slot-scope="text,record">
        <template>
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="handleUserManage(record)">人员管理</a>
          <a-divider type="vertical" />
          <a-popconfirm title="删除后不可恢复" @confirm="deleteShop(record)" okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>

    <a-modal
      title="操作"
      :width="1000"
      style="top: 20px;"
      :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
      v-model="visible"
      @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="名称" hasFeedback>
            <a-input
              v-decorator="[
          'name',
          {rules: [{ required: true, message: '请输入门店名称' }]}
        ]"
              placeholder="请输入门店名称"
            />
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="描述" hasFeedback>
            <a-textarea
              autosize
              v-decorator="[
          'desc',
          {rules: []}
        ]"
              placeholder="请输入描述"
            />
          </a-form-item>
          <a-form-item
              label="行业分类"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
          >
            <a-tree-select
                v-decorator="[
                        'cate_ids',
                        {rules: []}
                      ]"
                style=" width: 90% ; margin-right: 10px; "
                :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
                :treeData="cateOptions"
                multiple
                allowClear
                treeNodeFilterProp="title"
                placeholder='请选择行业分类'
                treeDefaultExpandAll
                v-model="formData.cate_ids"
            >
            </a-tree-select>
            <a-popover content="请选择分类,支持多选">
              <a-icon type="question-circle" />
            </a-popover>
          </a-form-item>

          <a-form-item
              label="服务标签"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
          >
            <template v-for="(tag, index) in formData.tags">
              <a-tooltip v-if="tag.length > 20" :key="tag" :title="tag">
                <a-tag :key="tag" :closable="index >= 0" @close="() => handleClose(tag)">
                  {{ `${tag.slice(0, 20)}...` }}
                </a-tag>
              </a-tooltip>
              <a-tag v-else :key="tag" :closable="index >= 0" @close="() => handleClose(tag)">
                {{ tag }}
              </a-tag>
            </template>
            <a-input
                v-if="inputVisible"
                ref="input"
                type="text"
                size="small"
                :style="{ width: '78px' }"
                :value="inputValue"
                @change="handleInputChange"
                @blur="handleInputConfirm"
                @keyup.enter="handleInputConfirm"
            />
            <a-tag v-else style="background: #fff; borderStyle: dashed;" @click="showInput">
              <a-icon type="plus" /> 新增标签
            </a-tag>
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="角标文字" hasFeedback>
            <a-input
                v-decorator="[
          'marker',
          {rules: []}
        ]"
                placeholder="请输入角标文字"
            />
          </a-form-item>
          <a-form-item
            label="列表小图"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            extra="显示在列表页,推荐尺寸750x750,推荐格式jpg"
          >
            <pic-uploader :file-list="formData.pic" />
          </a-form-item>

          <a-form-item
            label="内页大图"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            extra="显示详情页,推荐宽度不小于750像素 长宽比例为1:1的图片,推荐格式jpg"
          >
            <pic-uploader :file-list="formData.pics" />
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系电话" hasFeedback>
            <a-input
              v-decorator="[
          'phone',
          {rules: [{ required: true, message: '请输入商家联系电话' }]}
        ]"
              placeholder="请输入商家联系电话"
            />
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="地址" hasFeedback>
            <a-input
              v-decorator="[
          'address',
          {rules: [{ required: true, message: '请输入商家地址' }]}
        ]"
              placeholder="请输入商家地址"
            />
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="定位信息" hasFeedback>
            <!-- <div class="content-map">
              <el-amap
                ref="map"
                vid="amapDemo"
                :center="center"
                :zoom="12"
                :plugin="plugin"
                :events="events"
                class="amap-demo"
              >
                <el-amap-marker vid="amapDemo" :position="center"></el-amap-marker>
              </el-amap>
            </div>-->
            <div class="amap-page-container">
              <el-amap-search-box
                class="search-box"
                :search-option="searchOption"
                :on-search-result="onSearchResult"
                aria-placeholder="123456"
              ></el-amap-search-box>
              <el-amap
                vid="amapDemo"
                :center="center"
                :zoom="16"
                class="amap-demo"
                :events="events"
              >
                <el-amap-marker v-for="(marker,i) in markers" :position="marker" :key="i"></el-amap-marker>
              </el-amap>
            </div>
            <span style="color:red">友情提示:放大地图点击可精准定位!</span>
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="核销码" hasFeedback>
            <a-input
              v-decorator="[
          'order_code',
          {rules: [{ required: true, message: '请输入核销码' }]}
        ]"
              placeholder="核销码不能与其他门店重复,用于用户手动核销"
            />
          </a-form-item>

          <a-form-item label="详情介绍" v-if="visible" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <UEditor style="width: 400px; height:520px;" :ueditorContent.sync="formData.content"></UEditor>
          </a-form-item>
        </a-form>
      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>

    <a-modal
      title="人员管理"
      :width="1000"
      style="top: 20px;"
      :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
      v-model="userVisible"
      @ok="userVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-table
            :columns="userColumns"
            :dataSource="shopUserList"
            :pagination="false"
            rowKey="id"
            :scroll="{ y: 300 }"
            bordered
          >
            <span slot="name" slot-scope="name,record">
              <img :src="record.face" style="width: 40px; vertical-align: middle;" />
              {{record.name}} ({{record.phone}})
            </span>
            <template slot="action" slot-scope="text,record,index">
              <a-divider type="vertical" />
              <a-popconfirm
                title="确定删除此人员吗"
                @confirm="deleteUser(record,index)"
                okText="确定"
                cancelText="取消"
              >
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>
            <template slot="footer" slot-scope="text,record,index">
              <user-picker
                style="width: 200px; margin-right: 10px;"
                :formData="userFormData"
                field="user_id"
              />
              <users-picker
                style="width: 200px; margin-right: 10px;"
                :formData="userFormData"
                field="user_list"
              />

              <!--<a-select  style="width: 200px; margin-right: 10px;"  v-model="userFormData.type" placeholder="角色类型"  >-->
              <!--<a-select-option value="管理员">管理员</a-select-option>-->
              <!--<a-select-option value="店员">店员</a-select-option>-->
              <!--</a-select>-->
              <a-button icon="plus" @click="addUser">新增</a-button>
            </template>
          </a-table>
        </a-form>
      </a-spin>
    </a-modal>
  </a-card>
</template>
<script>
import STable from '@/components/table/'
import ATextarea from 'ant-design-vue/es/input/TextArea'
import AInput from 'ant-design-vue/es/input/Input'
import EditableCell from '@/components/EditableCell/'
import RSwitch from '@/components/RSwitch/'
import PicUploader from '@/components/PicUploader/'
import moment from 'moment'
import UEditor from '@/components/UEditor/'
import UserPicker from '@/components/UserPicker/'
import {
  getShopList,
  getShopDetail,
  addShop,
  editShop,
  deleteShop,
  setShopRank,
  getShopUserList,
  deleteShopUser,
  addShopUser
} from '@/api/businessShop'
import {
  getCateTreeList
} from '@/api/business'
import { truncate, constants } from 'fs'
import AMap from 'vue-amap'
import { axios } from '../../utils/axios'

export default {
  name: 'BusinessList',
  components: {
    AInput,
    ATextarea,
    STable,
    EditableCell,
    RSwitch,
    PicUploader,
    UEditor,
    UserPicker
  },
  data() {
    let that = this
    return {
      lng:118.7982559204,
      lat:32.0857743123,
      markers: [],
      searchOption: {
        city: '南京',
        citylimit: false
      },
      // mapCenter: [121.59996, 31.197646],

      center: [32.0857743123,118.7982559204],
      events: {
        init: o => {
          console.log(o.getCenter())
          // console.log(this.$refs.map.$$getInstance());
          o.getCity(result => {
            console.log(result)
          })
        },
        moveend: () => {},
        zoomchange: () => {},
        click: e => {
          that.markers = []
          that.center = [e.lnglat.lng, e.lnglat.lat] //点击选择新地址为中心点
          that.lng = e.lnglat.lng
          that.lat = e.lnglat.lat
          that.markers.push([e.lnglat.lng, e.lnglat.lat])
          console.log(that.center)
          console.log(that.markers)
          console.log(that.lng, that.lat)
        }
      },
      plugin: [
        'ToolBar',
        {
          pName: 'MapType',
          defaultType: 0,
          events: {
            init(o) {
              console.log(o)
            }
          }
        }
      ],

      inputVisible: false,
      inputValue: '',

      visible: false,
      userVisible: false,
      saveLoading: false,
      formData: {
        id: 0,
        cate_ids: [],
        name: '',
        desc: '',
        pic: [],
        pics: [],
        content: '',
        phone: '',
        address: '',
        order_code: '',
        rank: 0,
        status: 1
      },
      userFormData: {
        user_id: undefined,
        type: undefined,
        shop_id: 0
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      form: this.$form.createForm(this),
      mdl: {},

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        keywords: ''
      },
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '50px'
        },
        {
          title: '标题',
          dataIndex: 'title',
          scopedSlots: { customRender: 'title1' }
        },
        {
          title: '电话',
          width: '100px',
          dataIndex: 'phone'
        },
        {
          title: '地址',
          width: '200px',
          dataIndex: 'address'
        },
        {
          title: '核销码',
          width: '100px',
          dataIndex: 'order_code'
        },
        {
          title: '排序',
          width: '150px',
          dataIndex: 'rank',
          scopedSlots: { customRender: 'rank' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '180px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      //人员管理表头
      userColumns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '50px',
           scopedSlots: { customRender: 'id' }
        },
        {
          title: '用户名',
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' }
        } /*
          {
            title: '角色',
            width:'100px',
            dataIndex: 'role_type',
          },*/,
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      shopUserList: [],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData')
        console.log(this.queryParam)
        this.queryParam = Object.assign( this.queryParam, parameter)
        return getShopList(this.queryParam).then(res => {
          console.log('res')
          return res.data
        })
      },

      cateOptions: [],

      selectedRowKeys: [],
      selectedRows: []
    }
  },
  computed: {},
  created() {},
  mounted() {
    let that = this
    getCateTreeList().then(res => {
      this.cateOptions = res.data
      this.cateOptions.map(cate => {
        cate.id = cate.id + ''
      })
    })
  },
  methods: {
    moment,
    handleCancel() {
      this.visible = false
    }, 
    onSearchResult(pois) {
      let latSum = 0
      let lngSum = 0
      console.log(pois)
      if (pois.length > 0) {
        pois.forEach(poi => {
          let { lng, lat } = poi
          lngSum += lng
          latSum += lat
          this.markers.push([poi.lng, poi.lat])
        })
        let center = {
          lng: lngSum / pois.length,
          lat: latSum / pois.length
        }
        this.center = [center.lng, center.lat]
      }
    },

    handleClose(removedTag) {
      const tags = this.formData.tags.filter(tag => tag !== removedTag);
      console.log(tags);
      this.formData.tags = tags;
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(function() {
        this.$refs.input.focus();
      });
    },

    handleInputChange(e) {
      this.inputValue = e.target.value;
    },

    handleInputConfirm() {
      const inputValue = this.inputValue;
      let tags = this.formData.tags;
      if (inputValue && tags.indexOf(inputValue) === -1) {
        tags = [...tags, inputValue];
      }
      console.log(tags);
      this.formData.tags = tags
      Object.assign(this, {
        inputVisible: false,
        inputValue: '',
      });
    },
    // 增
    handleAdd() {

      this.visible = true
      this.form.resetFields()
      this.markers=[]
      // this.markers.push([118.7982559204, 32.0857743123])
      this.center = [118.7982559204, 32.0857743123]
      this.formData = {
        id: 0,
        cate_ids: [],
        tags: [],
        marker: '',
        name: '',
        desc: '',
        pic: [],
        pics: [],
        content: '',
        phone: '',
        order_code: '',
        address: '',
        rank: 0,
        status: 1,
        lng:this.lng,
        lat:this.lat
      }
      setTimeout(() => {
        this.form.setFieldsValue({ ...this.formData })
      }, 300)
    },
    // 改
    handleEdit(record) {
      let self = this
      getShopDetail({ id: record.id }).then(res => {
        setTimeout(() => {
          self.form.setFieldsValue({ ...res.data })
        }, 300)
        //          self.formData = {...res.data};
        self.formData = Object.assign(self.formData, res.data) //尼玛 日期选择器有bug 必须这样赋值
        self.formData.id = res.data.id
        self.center = [res.data.lng, res.data.lat]
        self.markers = [[res.data.lng, res.data.lat]] 
        self.searchOption.city = res.data.address.substr(0, 2)
      })

      this.visible = true
    },

    // 增改 处理
    handleOk(e) {
      let self = this
      console.log(self.formData.lng)
      console.log(self.markers)
      if (!self.markers.length) {
        self.$message.error('请在地图上标注位置')
      } else {
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)
            self.saveLoading = true
            let formData = {
              id: self.formData.id,
              cate_ids: self.formData.cate_ids,
              tags: self.formData.tags,
              name: values.name,
              marker: values.marker,
              desc: values.desc,
              pic: self.formData.pic,
              pics: self.formData.pics,
              phone: values.phone,
              order_code: values.order_code,
              address: values.address,
              content: self.formData.content,
              rank: values.rank,
              status: self.formData.status,
              lng: self.markers[0][0],
              lat: self.markers[0][1]
            }
            
            if (self.formData.id) {
              editShop(formData)
                .then(res => {
                  self.$message.success('修改成功')
                  self.$refs.table.refresh()
                  self.visible = false
                  self.saveLoading = false
                })
                .catch(err => {
                  self.$message.error(err.data.msg)
                  self.saveLoading = false
                })
            } else {
              addShop(formData)
                .then(res => {
                  self.$message.success('新增成功')
                  self.$refs.table.refresh()
                  self.visible = false
                  self.saveLoading = false
                })
                .catch(err => {
                  self.$message.error(err.data.msg)
                  self.saveLoading = false
                })
            }
          }
        })
      }
    },

    //
    handleUserManage(record) {
      let self = this
      console.log(record)
      self.userFormData.shop_id = record.id
      self.getShopUserList()
      this.userVisible = true
    },
    getShopUserList() {
      let self = this
      getShopUserList({ shop_id: self.userFormData.shop_id }).then(res => {
        self.shopUserList = res.data.list
      })
    },
    addUser() { 
      let self = this
      if (!self.userFormData.user_id) {
        self.$message.error('请选择人员')
        return
      }
      if (!self.userFormData.type) {
        //          self.$message.error('请选择类型');
        //          return ;
      }
      addShopUser(self.userFormData)
        .then(res => {
          self.userFormData.user_id = undefined
          self.userFormData.type = undefined
          self.$message.success('新增成功')
          self.getShopUserList()
        })
        .catch(err => {
          self.$message.error(err.data.msg)
        })
    },
    deleteUser(record, index) {
      let self = this
      deleteShopUser({
        user_id: record.user_id,
        shop_id: record.shop_id
      })
        .then(res => {
          self.$message.success('删除成功')
          self.shopUserList.splice(index, 1)
        })
        .catch(err => {
          self.$message.error(err.data.msg)
        })
    },

    // 删
    deleteShop(record) {
      let self = this
      deleteShop({ id: record.id })
        .then(res => {
          self.$message.success('删除成功')
          self.$refs.table.refresh(true)
        })
        .catch(err => {
          self.$message.error(err.data.msg)
        })
    },
    // 查
    onSearch() {
      let self = this
      self.$refs.table.refresh(true)
    },
    onRankChange(key, dataIndex, value) {
      let self = this
      setShopRank({
        id: key,
        rank: value
      })
        .then(res => {
          self.$refs.table.refresh(true)
        })
        .catch(err => {
          self.$message.error(err.data.msg)
        })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    }
  },
  watch: {
    /*
       'selectedRows': function (selectedRows) {
       this.needTotalList = this.needTotalList.map(item => {
       return {
       ...item,
       total: selectedRows.reduce( (sum, val) => {
       return sum + val[item.dataIndex]
       }, 0)
       }
       })
       }
       */
  }
}
</script>
<style scoped>
.content-map {
  height: 300px;
}
.amap-demo {
  height: 300px;
}

.search-box {
  position: absolute;
  top: 25px;
  left: 20px;
  width: 70%;
}

.amap-page-container {
  position: relative;
}
</style>

